import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class KrakenWebTooltipService {

  constructor() { }
}
